import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CloseIcon } from '@gem/icons';
import { PopupStore } from '@gem/popups';
import { customScrollStyles, Divider, IconButton, IconView, MenuItem } from '@gem/ui-kit';

import { Space } from 'STORE/Spaces/Space';

import { SpaceInfo } from './SpaceInfo/SpaceInfo';
import { useSpaceProfilePresenter } from './SpaceProfile.presenter';
import styles from './SpaceProfile.styles.m.css';

interface ISpaceProfileProps {
  className?: string;
  metaBlockClassName?: string;
  space: Space;
  popupInstance?: PopupStore;
  onClose?(): void;
}

export const SpaceProfile: FC<ISpaceProfileProps> = observer(
  ({ className, metaBlockClassName, space, popupInstance, onClose }) => {
    const presenter = useSpaceProfilePresenter({ space, popupInstance });

    return (
      <div className={classNames(className, styles.container, customScrollStyles.container)}>
        <SpaceInfo
          metaBlockClassName={metaBlockClassName}
          space={space}
          isShowOnboarding={presenter.isShowOnboarding}
          canUpdateDeepLink={presenter.canUpdateDeepLink}
          onUpdateDeepLink={presenter.onUpdateDeepLink}
        />

        {presenter.menu.length > 0 && (
          <>
            <Divider theme="style1" />
            {presenter.menu.map(({ key, title, count, icon, onClick }) => (
              <MenuItem
                className={styles.menuItem}
                key={key}
                title={title}
                count={count}
                icon={
                  <IconView
                    Icon={icon}
                    className={styles.menuItemIcon}
                  />
                }
                onClick={onClick}
              />
            ))}
          </>
        )}

        {presenter.actions.length > 0 && (
          <>
            <Divider theme="style1" />
            {presenter.actions.map(({ key, title, icon, onClick }) => (
              <MenuItem
                className={styles.menuItem}
                key={key}
                title={title}
                icon={
                  <IconView
                    Icon={icon}
                    className={styles.menuItemIcon}
                  />
                }
                onClick={onClick}
              />
            ))}
          </>
        )}

        {onClose && (
          <IconButton
            className={styles.close}
            Icon={CloseIcon}
            onClick={onClose}
          />
        )}
      </div>
    );
  }
);
